import React, { useEffect, useState, Fragment, useRef, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../AppContext/App.context";
import { makeStyles } from "@material-ui/core/styles";
import CameraAltOutlinedIcon from "@material-ui/icons/CameraAltOutlined";
import Grid from "@material-ui/core/Grid";
import CommonEndpoints from "../../services/commonApi.service";
import useApiService from "../../services/api.service";
import userDefaultIcon from "../../assets/images/resources/user.png";
import Input from "../../components/Input/Input";
import { useForm } from "react-hook-form";
import useToast from "../../components/Toast/hooks/useToast";
import Phone from "../../components/phone-picker/phone-picker";
import { ValidationService } from "../../utils/Validation";
import EditProfileEndpoints from "./EditProfile.endpoints";
import useLoader from "../../hooks/useLoader";
import useLocalStorage from "../../utils/localStorage";
import Btn from "../../components/Button/Button";
import headerDropdownService from "../../services/headerDropdown.service";

import "./EditProfile.scss";
import { useHistory } from "react-router";
import { themeColor } from "../../constants/themeColor";
import LoginEndpoints from "../Login/Login.endpoints";
import SendOtpPopup from "./SendOtpPopup";
import { IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    margin: "auto",
    paddingTop: "2rem",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "auto",
  },
  basicinfo: {
    padding: "12px",
    marginTop: "40px",
  },
  item: {
    display: "flex",
    justifyContent: "center",
    paddingBottom: "0px !important",
  },
  pageheading: {
    fontSize: "26px",
    fontWeight: 600,
    padding: "13px 20px",
    backgroundColor: `${themeColor.whiteColor}`,
    paddingLeft: "51px",
  },
  root: {
    width: "100%",
  },
  btn: {
    margin: theme.spacing(2),
  },
  pageSubheading: {
    fontSize: "20px",
    fontWeight: 500,
    backgroundColor: `${themeColor.whiteColor}`,
    paddingBottom: "1rem",
  },
}));

const EditProfile = (props: any, ref: any) => {
  const { t, i18n } = useTranslation(["Profile", "Common"]);
  const [isShownUploadProfilePictureIcon, showUploadProfilePictureIcon] =
    useState(false);
  const fileUpload: any = React.createRef();
  const [image, setImage]: any = useState(userDefaultIcon);
  const ApiService = useApiService();
  const [showOtpInput, setShowOtpInput]: any = useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [appData]: any = useAppContext();
  const { register, handleSubmit, errors, getValues, setValue, reset, watch } =
    useForm({
      mode: "onChange",
    });
  const history: any = useHistory();
  const [password, setPassword] = useState("");
  const { password: confirmPassword } = watch();
  const [showPassword, setShowPassword] = useState({
    showPass: false,
    showConfirmPass: false,
  });

  const referenceId = useLocalStorage.getItem("referenceId");
  const access_token = appData.loginData.access_token;
  const classes = useStyles();
  const toaster = useToast();
  const dialCode: any = useRef<any>();
  const countryCode: any = useRef();
  const loader: any = useLoader();
  const otpPopupRef: any = useRef();
  const [preSavedCountryCode, updatePreSavedCountryCode]: any = useState();

  const localStorage = useLocalStorage;

  const details = appData.loginData;

  useEffect(() => {
    setPrefillProfile(details);
  }, []);

  const setPrefillProfile = (details: any) => {
    if (details) {
      reset({
        name: details.name,
        phone: details.phone_number,
        email: details.email,
        //image:  res[0].user_image,
      });
      updatePreSavedCountryCode(
        details.country_code
          ? details.country_code.substring(1)
          : preSavedCountryCode
      );
      if (details.user_image) {
        setImage(details.user_image);
      } else {
        setImage(userDefaultIcon);
      }
    }
    setIsLoading(false);
  };

  const ImageHandler = async (ev: any) => {
    const formData = new FormData();
    formData.append("file", ev.target.files[0]);
    formData.append("entity", "resource");
    loader.showLoader();
    if (!ev.target.files[0]) {
      loader.hideLoader();
    }
    const res = await ApiService.postFormData(
      CommonEndpoints.uploadImage(formData)
    ).then((res: any) => {
      setImage(res.data.url);
      loader.hideLoader();
    });
  };

  const showFileUpload = () => {
    fileUpload.current.click();
  };

  const obj = {
    name: {
      required: ValidationService.requiredValidator(),
    },
    phone: {
      required: ValidationService.requiredValidator(),
    },
    email: {
      required: ValidationService.requiredValidator(),
      pattern: ValidationService.emailValidator(),
    },
    otp: {},
    password: {
      // required: ValidationService.requiredValidator(),
      pattern: ValidationService.passwordValidator(),
    },
    confirm_password: {
      // required: "Confirm Password is required",
      validate: (value: string) =>
        value === password || "Passwords do not match",
    },
  };
  const submitDetailsOTP = (data: any) => {
    handleChangeBasicInfo(data);
  };
  const handleChangeBasicInfo = (data: any) => {
    if (!data.name.trim()) {
      toaster.addToast({
        message: "Please enter valid name",
        timeout: 3000,
        type: "error",
      });
      return;
    }
    const request: any = {};
    if (data.name.trim()) {
      request["name"] = data.name.trim();
    }
    if (image !== userDefaultIcon) {
      request["user_image"] = image;
    }
    if (data?.password?.trim()) {
      request["new_password"] = data.password;
    }
    request["email"] = data.email;

    if (data.otp) {
      request["otp_code"] = data.otp;
      request["country_code"] = dialCode.current;
      let tempNumber = data?.phone.replace(/[^0-9]/g, "");
      request["phone_number"] = parseInt(tempNumber);
    } else {
      // request["otp_code"] = details.otp_code;
    }

    const headers = {
      access_token: appData.loginData.access_token,
      reference_id: referenceId,
    };
    const reqData = {
      reqBody: request,
      headers: headers,
    };
    loader.showLoader();
    return ApiService.put(EditProfileEndpoints.updateProfile(reqData))
      .then((res: any) => {
        loader.hideLoader();
        let loginData = appData.loginData;
        loginData.name = res.data.name;
        loginData.email = res.data.email;
        loginData.access_token = res.data.access_token;
        loginData.user_image = image;
        loginData.phone_number = res.data.phone_number;
        loginData.country_code = res.data.country_code;
        localStorage.setItem("loginData", loginData);
        toaster.addToast({
          message: res.message,
          timeout: 3000,
          type: "success",
        });
        let imageforHeader: any = { type: "ProfileImage", value: image };
        headerDropdownService.emit(imageforHeader);
        setShowOtpInput(false);
        otpPopupRef.current.handleClose(false);
        setValue("password", "", { shouldValidate: false });
        setValue("confirm_password", "", { shouldValidate: false });
      })
      .catch((err: any) => {
        loader.hideLoader();
        toaster.addToast({
          message: err?.message,
          timeout: 3000,
          type: "error",
        });
      });
  };

  const fetchDialCode = (dialcode: any, countrycode: any) => {
    dialCode.current = "+" + dialcode;
    countryCode.current = countrycode.toUpperCase();
  };
  const handleOtpVerification = async (data: any) => {
    await sendOTP(data);
  };
  const sendOTP = async (data: any) => {
    const request: any = {
      country_code: dialCode.current,
      phone_number: data.phone,
      app_version: "100.1",
    };
    const headers = {
      access_token: appData.loginData.access_token,
      reference_id: useLocalStorage.getItem("referenceId"),
    };
    const reqData = {
      reqBody: request,
      headers: headers,
    };

    return ApiService.post(LoginEndpoints.otpValidation(reqData))

      .then(async (res: any) => {
        loader.hideLoader();
        toaster.addToast({
          message: t("LoginViaOTP:OTP Sent Successfully"),
          timeout: 2000,
          type: "success",
        });
        otpPopupRef.current.handleOpen({
          ...data,
          country_code: dialCode.current,
        });
        setShowOtpInput(true);
      })
      .catch((err) => {
        loader.hideLoader();
        toaster.addToast({
          message: err.message,
          timeout: 3000,
          type: "error",
        });
      });
  };

  const handleFormSubmit = async (data: any) => {
    if (
      details.phone_number != data.phone ||
      details.country_code != dialCode.current
    ) {
      handleOtpVerification(data);
    } else {
      handleChangeBasicInfo(data);
    }
  };

  const handleClickShowPassword = (showPass: any) => {
    if (showPass) {
      setShowPassword({ ...showPassword, showPass: !showPassword.showPass });
    } else {
      setShowPassword({
        ...showPassword,
        showConfirmPass: !showPassword.showConfirmPass,
      });
    }
  };

  return (
    <div className="EditProfile">
      <div className={classes.pageheading}>{t("Profile:Edit Profile")}</div>

      <div className="EditProfile__paper">
        {isLoading ? (
          <div></div>
        ) : (
          <div className={classes.root}>
            <Grid
              item
              xs={12}
              className="editBasicInfo__form__container"
              // style={{ paddingLeft: "28px" }}
            >
              <div className={classes.basicinfo}>
                <form
                  className="changeBasicInfo"
                  onSubmit={handleSubmit(handleFormSubmit)}
                >
                  <Grid container className="editProfile__input__section">
                    <Grid item xs={5} className="input__container">
                      <Grid container spacing={2}>
                        <Grid item xs={12} style={{ marginTop: "5px" }}>
                          <Input
                            type="text"
                            id="name"
                            name="name"
                            refValue={register(obj.name)}
                            errors={errors}
                            label={t("Common:Full Name")}
                          ></Input>
                        </Grid>
                        <Grid item xs={12}>
                          <Input
                            type="text"
                            id="email"
                            name="email"
                            refValue={register(obj.email)}
                            errors={errors}
                            label={t("Common:Email ID")}
                          ></Input>
                        </Grid>
                        <Grid item xs={12}>
                          <Phone
                            hideLabel={true}
                            showPhone={true}
                            setDialCode={(dialcode: any, countrycode: any) => {
                              fetchDialCode(dialcode, countrycode);
                            }}
                            name="phone"
                            id="phone"
                            label={t("Common:Mobile Number")}
                            refValue={register(obj.phone)}
                            placeholder={t("Common:Enter Mobile Number") + "*"}
                            disabled={false}
                            required={true}
                            errors={errors}
                            defaultPhone={preSavedCountryCode}
                          ></Phone>
                        </Grid>
                        <Grid item xs={12}>
                          <div className={classes.pageSubheading}>
                            {t("Profile:Change Password")}
                          </div>
                          <div style={{ marginBottom: "0.75rem" }}>
                            <Input
                              type={showPassword.showPass ? "text" : "password"}
                              id="password"
                              name="password"
                              onchange={(e: any) => setPassword(e.target.value)}
                              refValue={register(obj.password)}
                              errors={errors}
                              placeholder="Enter Your Password"
                              label={t("Common:Password") + "*"}
                              // InputProps={{
                              //   endAdornment: (
                              //     <IconButton
                              //       aria-label="toggle password visibility"
                              //       onClick={() =>
                              //         handleClickShowPassword(true)
                              //       }
                              //     >
                              //       {!showPassword.showPass ? (
                              //         <Visibility />
                              //       ) : (
                              //         <VisibilityOff />
                              //       )}
                              //     </IconButton>
                              //   ),
                              // }}
                            ></Input>
                          </div>
                          <Input
                            type={
                              showPassword.showConfirmPass ? "text" : "password"
                            }
                            id="confirm_password"
                            name="confirm_password"
                            refValue={register(obj.confirm_password)}
                            errors={errors}
                            placeholder="Enter Your Confirm Password"
                            label={t("Common:Confirm Password") + "*"}
                            InputProps={{
                              endAdornment: (
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => handleClickShowPassword(false)}
                                >
                                  {!showPassword.showConfirmPass ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              ),
                            }}
                          ></Input>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={6} className="input__container_1">
                      <div className="EditProfile__profile-picture-container">
                        <img
                          src={image}
                          alt="user icon"
                          onMouseEnter={() =>
                            showUploadProfilePictureIcon(true)
                          }
                          onClick={() => {
                            showUploadProfilePictureIcon(true);
                            showFileUpload();
                          }}
                          onMouseLeave={() =>
                            showUploadProfilePictureIcon(false)
                          }
                        ></img>
                        {isShownUploadProfilePictureIcon ? (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={showFileUpload}
                            onMouseEnter={() =>
                              showUploadProfilePictureIcon(true)
                            }
                            onMouseLeave={() =>
                              showUploadProfilePictureIcon(false)
                            }
                            className="EditProfile__profile-picture-container__camera"
                          >
                            <CameraAltOutlinedIcon color="inherit"></CameraAltOutlinedIcon>
                          </div>
                        ) : (
                          ""
                        )}
                        <input
                          accept="image/*"
                          type="file"
                          className="EditProfile__profile-picture-container__upload-input"
                          onChange={ImageHandler}
                          ref={fileUpload}
                        ></input>
                      </div>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      className="input__container_2"
                    >
                      <Btn
                        className={classes.btn}
                        type={"Submit"}
                        btnText={t("Common:Submit")}
                      ></Btn>
                      <Btn
                        className={classes.btn}
                        onClick={() => {
                          //clearFields();
                          // getUserProfileDetails(details.email.toString());
                          setPrefillProfile(details);
                          history.push("/jobs/list");
                        }}
                        color={"default"}
                        type={"button"}
                        btnText={t("Common:Cancel")}
                      ></Btn>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </Grid>

            {/* <Grid item xs={12}>
              <ChangePassword />
            </Grid> */}

            {/* <Grid item xs={11}>
              <DeleteAccount></DeleteAccount>
            </Grid> */}
          </div>
        )}
      </div>
      <Suspense fallback={<h3>Loading&hellip;</h3>}>
        <SendOtpPopup
          ref={otpPopupRef}
          updateDetails={submitDetailsOTP}
        ></SendOtpPopup>
      </Suspense>
    </div>
  );
};

export default EditProfile;
